import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const folderplus: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M19.5,15 L19.5,20 M17,17.5 L22,17.5 M15,17.5 L4.5,17.5 L4.5,8.5 L14.5,8.5 L15.5,6.5 L19.495,6.5 L19.5,13"
      />
    </svg>
  );
};
